import { isEmpty, toNumber, sortBy } from 'lodash'
import utils from './utils'
import { SecondParty } from '@node/wam-audience-builder'

const helpers = {
    parseMarketPlacePageData: secondParty => {
        const _secondPartyData = []
        for (const provider of secondParty) {
            const _provider = {
                access_key: provider.access_key,
                status: provider.status,
                label: provider.label,
                id: toNumber(provider.id),
                isSelectable: true,
                hasChild: true,
                children: isEmpty(provider.taxonomies) ? [] : utils.parseMarketPlacePageTaxonomies(provider.taxonomies),
                parentJsonKeyName: null,
                jsonKey: {
                    ids: [toNumber(provider.id)],
                    name: 'provider_' + provider.id,
                    type: 'SecondPartyCluster',
                    subType: 'provider'
                }
            }
            _secondPartyData.push(_provider)
        }
        return _secondPartyData
    },
    parseBuilderPagedData: secondParty => {
        let _secondPartyData = {}
        for (const provider of sortBy(secondParty, 'label')) {
            const _list = []

            if (!isEmpty(provider.taxonomies)) {
                for (const taxo of sortBy(provider.taxonomies, 'label')) {
                    _list.push({
                        status: taxo.status,
                        id: toNumber(taxo.id),
                        label: taxo.label,
                        isSelectable: false,
                        hasChild: !isEmpty(taxo.clusters),
                        parentJsonKeyName: null,
                        jsonKey: {
                            ids: [toNumber(taxo.id)],
                            name: 'taxo_' + taxo.id,
                            type: 'SecondPartyCluster',
                            subType: 'taxonomy',
                            parentName: provider.label
                        }
                    })

                    if (!isEmpty(taxo.clusters)) {
                        _list.push(...helpers.parseClusters(sortBy(taxo.clusters, 'label'), provider.label, false))
                    }
                }
            }
            if (!isEmpty(_list)) {
                _secondPartyData = {
                    ..._secondPartyData,
                    [provider.label]: {
                        type: 'secondParty',
                        subType: provider.label,
                        list: _list
                    }
                }
            }
        }
        return _secondPartyData
    },
    parseClusters: (clusters, parentName, isClusterChild) => {
        const _clusters = []
        for (const cluster of clusters) {
            const hasChild = cluster.hasOwnProperty('children') && !isEmpty(cluster.children)
            _clusters.push({
                status: cluster.status,
                account_status: cluster.account_status,
                id: toNumber(cluster.id),
                label: cluster.label,
                isSelectable: true,
                hasChild,
                parentJsonKeyName: isClusterChild ? 'cluster_' + cluster.parent_second_party_cluster_id : 'taxo_' + cluster.second_party_taxonomy_id,
                jsonKey: {
                    ids: [toNumber(cluster.id)],
                    name: 'cluster_' + cluster.id,
                    type: 'SecondPartyCluster',
                    subType: 'cluster',
                    parentName
                }
            })

            if (hasChild) {
                _clusters.push(...helpers.parseClusters(cluster.children, parentName, true))
            }
        }
        return _clusters
    },

    instanciateAll: (providers) => {
        const dataSet = []

        const _parseClusters = (dataSet, provider, parentId, clusters) => {
            clusters.forEach(cluster => {
                dataSet.push({
                    id: parseInt(cluster.id),
                    label: cluster.label,
                    providerId: provider.id,
                    path: ['MarketPlace', provider.label],
                    selectable: cluster.account_status === 'active',
                    parentId
                })
    
                const crossId = SecondParty.generateCrossId({
                    category: 'SecondParty',
                    subCategory: 'Cluster',
                    id: cluster.id
                })
    
                // recursive parse
                if (cluster.children) _parseClusters(dataSet, provider, crossId, cluster.children )
                
            })
        }

        providers.forEach(provider => {
            
            provider.taxonomies.forEach(taxo => {
                const id = `${provider.id}.${taxo.id}`

                dataSet.push({
                    id: parseInt(id),
                    label: taxo.label,
                    subCategory: 'Taxonomie',
                    path: ['MarketPlace', provider.label],
                    selectable: false
                })
    
                const crossId = SecondParty.generateCrossId({
                    category: 'SecondParty',
                    subCategory: 'Taxonomie',
                    id: parseInt(id),
                })
    
                _parseClusters(dataSet, provider, crossId, taxo.clusters)
            })
        })

        return SecondParty.createAll(dataSet)
    },
}

export default helpers
